import Hashids from 'hashids';

const hashids = new Hashids('magna-sales-portal', 5);

export const encodeId = (id) => {
    if (!id) return;
    const encode = hashids.encode(id);
    return encode;
};

export const decodeId = (id) => {
    if (!id) return;
    const decoded = hashids.decode(id);
    return decoded.length > 0 ? decoded[0] : null;
};

